import { render, staticRenderFns } from "./infoAlert.vue?vue&type=template&id=078c1441&"
import script from "./infoAlert.vue?vue&type=script&lang=js&"
export * from "./infoAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports